import '../scss/main.scss';

import Nav from './components/Nav';
import LoadImage from './components/LoadImage';
import Accordion from './components/Accordion';
import ShowMenu from './components/ShowMenu';
import HideOnScroll from './components/HideOnScroll';
import LanguageSwitch from './components/LanguageSwitch';
import Share from './components/Share';
import FadeIn from './components/FadeIn';
import HideBackground from './components/HideBackground';
import Drag from './components/Drag';
import initSliderSwipers from './components/SliderSwiper';
import fsLightbox from 'fslightbox';
import Swiper from 'swiper';
import { Autoplay, Navigation, Pagination } from 'swiper/modules';
import 'swiper/swiper.css';
import 'swiper/modules/navigation.css';
import 'swiper/modules/scrollbar.css';

document.querySelectorAll('.language__switch').forEach(() => {
	new LanguageSwitch();
});

document.querySelectorAll('.js-nav').forEach((el) => {
	new Nav(el);
});

document.querySelectorAll('.js-load-image').forEach((el) => {
	new LoadImage(el);
});

document.querySelectorAll('.js-accordion').forEach((el) => {
	new Accordion(el);
});

document.querySelectorAll('.nav').forEach(() => {
	new ShowMenu();
});

document.querySelectorAll('.js-hide-on-scroll').forEach((el) => {
	new HideOnScroll(el);
});

document.querySelectorAll('.js-share').forEach((el) => {
	new Share(el);
});

document.querySelectorAll('.fade-in').forEach((el) => {
	new FadeIn(el);
});

document.querySelectorAll('.HideBackground').forEach((el) => {
	new HideBackground(el);
});

document.querySelectorAll('.Drag').forEach((el) => {
	new Drag(el);
});

initSliderSwipers();

document.querySelectorAll('.room-swiper').forEach((el) => {
	new Swiper(el, {
		modules: [Autoplay, Navigation, Pagination],
		slidesPerView: 1,
		spaceBetween: 0,
		loop: true,
		navigation: {
			nextEl: el.querySelector('.swiper-button-next'),
			prevEl: el.querySelector('.swiper-button-prev'),
		},
		pagination: {
			el: el.querySelector('.swiper-pagination'),
			clickable: true,
		},
		grabCursor: true,
	});
});

document.querySelectorAll('.promo-catering-swiper').forEach((el) => {
	new Swiper(el, {
		modules: [Autoplay, Navigation, Pagination],
		slidesPerView: 1,
		spaceBetween: 0,
		loop: true,
		navigation: {
			nextEl: el.querySelector('.swiper-button-next'),
			prevEl: el.querySelector('.swiper-button-prev'),
		},
		pagination: {
			el: el.querySelector('.swiper-pagination'),
			clickable: true,
		},
		grabCursor: true,
	});
});
